
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      matches: [],
    };
  },
  inject: [`team`, `post`],
  computed: {
    statTypes () {
      const position = this.player.position === `Goalkeeper` ? `goalkeeper` : `outfield`;
      return this.post?.acf?.player_page_config?.match_summary_stats[position].playerstattype;
    },
    year () {
      const period = this.getDefault(`calendarperiod`);
      const seasons = period.displayName.split(`Season `);
      return seasons[1].split(`/`)[0];
    },
    headings () {
      const headings = [{ title: `Date` }, { title: `Opponent` }, { title: `Start` }];
      if (this.matches?.length) {
        const match = this.matches[0];
        for (const stat of this.statTypes) {
          headings.push({
            title: match.playerStats[stat.displayName].display_name,
            short: match.playerStats[stat.displayName].abbreviation,
          });
        }
      }
      return headings;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getMatchSummary();
    });
  },
  methods: {
    async getMatchSummary () {
      const params = {
        stat_types: this.statTypes.map(statType => statType.displayName).join(`||`),
        start_year: this.year,
      };

      const request = await this.$getCustomStats(`match-summary/team/${this.team.id}/player/${this.player.player.id}`, params);
      if (request !== null) {
        this.matches = request;
      }
    },
  },
};
